import {
	ADMINADDORUPDATEKYCDOCUMENT_SUCCESS,
	ADMINADDORUPDATEKYCDOCUMENT_FAILED,
	RESET_ADMINADDORUPDATEKYCDOCUMENT,
	LOADING_ADMINADDORUPDATEKYCDOCUMENT,
	NETWORK_ERROR_ADMINADDORUPDATEKYCDOCUMENT
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminAddOrUpdateKycDocument = () => {
	return { type: RESET_ADMINADDORUPDATEKYCDOCUMENT };
};

const adminAddOrUpdateKycDocument =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINADDORUPDATEKYCDOCUMENT });
		await adminServices
			.post("createOrUpdateKycDocumentType", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminAddOrUpdateKycDocumentsuccess(res.data));
						break;
					default:
						dispatch(adminAddOrUpdateKycDocumentFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINADDORUPDATEKYCDOCUMENT,
					payload: err
				});
			});
	};
function adminAddOrUpdateKycDocumentsuccess(data) {
	return {
		type: ADMINADDORUPDATEKYCDOCUMENT_SUCCESS,
		payload: data
	};
}
function adminAddOrUpdateKycDocumentFailed(data) {
	return {
		type: ADMINADDORUPDATEKYCDOCUMENT_FAILED,
		payload: data
	};
}

export { resetAdminAddOrUpdateKycDocument, adminAddOrUpdateKycDocument };
